<template>
  <div>
    <v-toolbar

      card
      dense
      height="32"

    >
      <v-icon small pa-0 >directions</v-icon>
      <v-toolbar-title style="margin-left: 8px;">
        <h6>Expeditions</h6>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        small
        depressed
        round
        
        flat
        v-if="!editedItemId && editable"
        @click="newItem"

      
      >
        <v-icon small class="pr-2">add</v-icon>Add an expedition
      </v-btn>
    </v-toolbar>
    <div>
      <v-data-table
        class="fixedtables"
        :headers="fetchHeaders()"
        :items="editableItems"
        :pagination.sync="pagination"
        hide-actions
      >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom class="smallhead">
            <span slot="activator">{{ getHeaderTitle(props.header) }}</span>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
          <div class="largehead">
            <span>{{ props.header.text }}</span>
          </div>
        </template>
        <template slot="items" slot-scope="props">
          <tr class="clickable" @click="edit(props.item)">
            <td
              style="width: 1%; white-space: nowrap; height: 28px;"
              v-if="!previsional"
            >
              <div>{{ props.item.number }}</div>
            </td>

            <!-- Shipping Company -->
            <td style="width: 1%; white-space: nowrap; height: 28px;">
              <div v-if="isEdited(props.item)">
                <v-autocomplete
                  :items="supplierShippingCompanies()"
                  background-color="white"
                  item-value="id"
                  item-text="name"
                  v-model="editedItem.shipping_company_id"
                  placeholder="select a shipping company"
                  no-data-text="No companies available"
                  required
                  class="small-font"
                />
              </div>
              <div v-else>
                {{
                  props.item.shipping_company
                    ? props.item.shipping_company.name
                    : ""
                }}
              </div>
            </td>

            <!-- Quantity -->
            <td style="width: 1%; white-space: nowrap; height: 28px;">
              <div v-if="isEdited(props.item) && previsional">
                <v-text-field
                  v-model="editedItem.quantity"
                  placeholder="select a quantity"
                  class="small-font"
                  v-on:keyup.enter="createOrUpdateItem"
                  required
                />
              </div>
              <div v-else>{{ props.item.quantity }}</div>
            </td>

            <!-- Shipment -->
            <td style="width: 1%; white-space: nowrap; height: 28px;">
              <div v-if="isEdited(props.item)">
                <v-autocomplete
                  :items="supplierShipments()"
                  background-color="white"
                  item-value="id"
                  item-text="name"
                  v-model="editedItem.shipment_id"
                  placeholder="select a shipment"
                  no-data-text="No shipments available"
                  required
                  class="small-font"
                  v-on:keyup.enter="createOrUpdateItem"
                />
              </div>
              <div v-else>
                <v-icon small class="pr-2">
                  {{ props.item.shipment ? props.item.shipment.icon : "" }}
                </v-icon>
                {{ props.item.shipment ? props.item.shipment.name : "" }}
              </div>
            </td>

            <td style="width: 1%; white-space: nowrap; height: 28px;">
              <div v-if="isEdited(props.item)">
                <v-text-field
                  v-model="editedItem.net_weight"
                  placeholder="select a net weight"
                  class="small-font"
                  v-on:keyup.enter="createOrUpdateItem"
                  required
                />
              </div>
              <div v-else>{{ props.item.net_weight }}mt</div>
            </td>

            <!-- Total Loaded Net Weight -->
            <td
              style="width: 1%; white-space: nowrap; height: 28px;"
              v-if="!previsional"
            >
              <v-tooltip right>
                <span slot="activator">
                  {{ ExpeditionTotalLoadedNetWeight(props.item).toFixed(3) }}mt
                  / {{ totalNetWeightInMT(previsional).toFixed(3) }}mt
                  <v-icon small size="14" class="grey--text">help</v-icon>
                </span>

                <span>
                  <span
                    v-for="(su, index) in props.item.shipping_units"
                    :key="index"
                  >
                    <v-icon size="12" class="white--text">{{
                      props.item.shipment.icon
                    }}</v-icon>
                    #{{ index + 1 }}:
                    <strong
                      >{{
                        ShippingUnitTotalLoadedNetWeight(su).toFixed(3)
                      }}mt</strong
                    >
                    <br />
                  </span>
                </span>
              </v-tooltip>
            </td>

            <!-- Total (mt) -->
            <td
              style="width: 1%; white-space: nowrap; height: 28px;"
              v-if="previsional"
            >
              <div>{{ props.item.net_weight * props.item.quantity }}mt</div>
            </td>

            <!-- Estimated Departure Date -->
            <td style="width: 1%; white-space: nowrap; height: 28px;">
              <v-layout row wrap align-center>
                <div
                  v-if="isEdited(props.item)"
                  v-on:keyup.enter="createOrUpdateItem"
                >
                  <date-field
                    :currentDate="editedItem.etd"
                    v-model="editedItem.etd"
                  />
                </div>
                <div v-else>
                  {{ props.item.etd ? props.item.etd.substring(0, 10) : "" }}
                </div>
              </v-layout>
            </td>

            <td
              style="width: 1%; white-space: nowrap; height: 28px;"
              class="min-width clickable"
            >
              <v-layout justify-end align-center row>
                <div v-if="isEdited(props.item)">
                  <v-layout row>
                    <v-btn icon small flat @click.stop="createOrUpdateItem">
                      <v-icon small color="success">done</v-icon>
                    </v-btn>
                    <v-btn icon small flat @click.stop="endEdit">
                      <v-icon small color="error">clear</v-icon>
                    </v-btn>
                  </v-layout>
                </div>
                <div v-else>
                  <template v-if="!previsional">
                    <v-tooltip bottom>
                      <v-btn
                        slot="activator"
                        icon
                        small
                        flat
                        @click.stop="showBuyBankInvoiceDialog(props.item)"
                        color="ctcRed"
                      >
                        <v-icon small
                          >receipt</v-icon
                        >
                      </v-btn>
                      <span>Show purchase invoice</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <v-btn
                        slot="activator"
                        icon
                        small
                        flat
                        @click.stop="showSellBankInvoiceDialog(props.item)"
                        color="ctcGreen"
                      >
                        <v-icon small
                          >receipt</v-icon
                        >
                      </v-btn>
                      <span>Show selling invoice</span>
                    </v-tooltip>
                  </template>
                  <destroyModale
                    v-if="editable"
                    resourceName="expedition"
                    :itemId="props.item.id"
                    warningText="You are going to remove this expedition permanently."
                    small
                    :icon="true"
                    :fab="false"
                    :small_icon="true"
                  />
                </div>
              </v-layout>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <div class="text-xs-center">
            <v-btn flat color=" primary" depressed @click="newItem">
              <v-icon class="pr-2" small>add_circle</v-icon>Add an expedition.
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dateField from "../shared/dateField";
import CREATE_EXPEDITION from "../../graphql/expeditions/create.gql";
import UPDATE_EXPEDITION from "../../graphql/expeditions/update.gql";
import scoreProducts from "../../mixins/scoreProducts.js";
import optimistic from "../../mixins/optimistic";
import editableItems from "../../mixins/editableItems";

export default {
  name: "expeditions",
  mixins: [scoreProducts, optimistic, editableItems],
  components: {
    dateField,
  },
  props: {
    previsional: {
      type: Boolean,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      resourceName: "expedition",
      createMutation: CREATE_EXPEDITION,
      updateMutation: UPDATE_EXPEDITION,
      lastCategory: "",
      pagination: {
        sortBy: "number",
        descending: false,
        rowsPerPage: -1,
      },
    };
  },
  computed: {
    ...mapGetters("contractStore", [
      "contract",
      "previsional_expeditions",
      "real_expeditions",
      "totalNetWeightInMT",
      "totalBuyingPrice",
      "totalSellingPrice",
    ]),
    ...mapGetters("commonStore", ["shipments", "getNameById"]),
    editableItems() {
      if (this.previsional) return this.previsional_expeditions;
      else return this.real_expeditions;
    },
  },
  methods: {
    showBuyBankInvoiceDialog(expedition) {
      if (expedition.bank_invoice_links.length > 0) {
        var bil = expedition.bank_invoice_links.find(
          (e) => e.origin === "buying_expedition"
        );
        if (bil) return this.showBankInvoiceDialog(bil.bank_invoice);
      }
      /* Prefill default value for buying product bank invoice */
      let nbExp = this.contract.expeditions.length;
      var bi = {
        expedition_id: expedition.id,
        amount: this.totalBuyingPrice(false), // TODO Fix this value when merging with the new expedition system
        designation: `${this.contract.name} - #${expedition.number} Buy Products`,
        currency_id: this.contract.supplier_currency_id,
        subsidiary_company_id: this.contract.buying_company_id,
        company_id: this.contract.supplier_company.id,
        operation_type: "debit",
      };
      //bi.supplier_type_id = scoreCost.supplier_type_id;
      this.showBankInvoiceDialog(bi);
    },
    showSellBankInvoiceDialog(expedition) {
      if (expedition.bank_invoice_links.length > 0) {
        var bil = expedition.bank_invoice_links.find(
          (e) => e.origin === "selling_expedition"
        );
        if (bil) return this.showBankInvoiceDialog(bil.bank_invoice);
      }
      /* Prefill default value for selling product bank invoice */
      var bi = {
        expedition_id: expedition.id,
        amount: this.totalSellingPrice(false), // TODO Fix this value when merging with the new expedition system
        designation: `${this.contract.name} - #${expedition.number} Sell Products`,
        currency_id: this.contract.customer_currency_id,
        subsidiary_company_id: this.contract.selling_company_id,
        company_id: this.contract.customer_company.id,
        invoice_number: `${this.contract.name}.${expedition.number}`,
        operation_type: "credit",
      };
      this.showBankInvoiceDialog(bi);
    },
    showBankInvoiceDialog(bankInvoice) {
      this.$store.commit("contractStore/showBankInvoiceDialog", {
        value: true,
        editedItem: bankInvoice,
      });
    },
    fetchHeaders() {
      if (this.previsional)
        return [
          {
            text: "shipping company",
            align: "left",
            sortable: true,
            value: "shipping_company_id",
          },
          {
            text: "Quantity",
            align: "left",
            sortable: true,
            value: "quantity",
            width: "1%",
          },
          {
            text: "shipment",
            align: "left",
            sortable: true,
            value: "shipment_id",
          },
          {
            text: "Net Weight per Unit",
            align: "left",
            sortable: false,
            value: "",
            width: "1%",
          },
          {
            text: "Total (mt)",
            align: "left",
            sortable: false,
            value: "",
            width: "1%",
          },
          {
            text: "Estimated Time of Departure",
            shortText: "ETD",
            align: "left",
            sortable: true,
            value: "etd",
          },
          {
            text: "Actions",
            align: "right",
            sortable: false,
          },
        ];
      else
        return [
          {
            text: "Number",
            shortText: "#",
            align: "left",
            sortable: true,
            value: "number",
          },
          {
            text: "Shipping Company",
            align: "left",
            sortable: true,
            value: "shipping_company_id",
          },
          {
            text: "Quantity",
            shortText: "QTY",
            align: "left",
            sortable: true,
            value: "quantity",
            width: "1%",
          },
          {
            text: "Shipment",
            align: "left",
            sortable: true,
            value: "shipment_id",
          },
          {
            shortText: "Net Weight per Unit",
            text: "Expected loaded net weight per Unit",
            align: "left",
            sortable: false,
            value: "",
            width: "1%",
          },
          {
            text: "Total Loaded Net Weight (mt)",
            shortText: "Net Weight (mt)",
            align: "left",
            sortable: false,
            value: "",
            width: "1%",
          },
          {
            text: "Estimated Time of Departure",
            shortText: "ETD",
            align: "left",
            sortable: true,
            value: "etd",
          },
          {
            text: "Actions",
            align: "right",
            sortable: false,
          },
        ];
    },
    ShippingUnitTotalLoadedNetWeight(shipping_unit) {
      let total = 0;
      shipping_unit.shipping_unit_products.forEach((sup) => {
        total += sup.loaded_net_weight_mt;
      });
      return total;
    },

    ExpeditionTotalLoadedNetWeight(expedition) {
      let total = 0;
      if (!expedition.shipping_units) return 0;
      expedition.shipping_units.forEach((shipping_unit) => {
        shipping_unit.shipping_unit_products.forEach((sup) => {
          total += sup.loaded_net_weight_mt;
        });
      });
      return total;
    },
    supplierShipments() {
      return this.contract.supplier_company.supplier.shipments;
    },
    supplierShippingCompanies() {
      if (!this.editedItem.shipment_id) return [];
      let ret = this.contract.supplier_company.supplier.shipping_companies;
      /* if select only shipping companies using the selected shipment */
      ret = ret.filter(
        (c) =>
          c.supplier &&
          c.supplier.shipment_ids.includes(this.editedItem.shipment_id)
      );
      /* filter shipping companies forbidden by customer */
      if (this.contract.customer_company.customer.company_ids.length) {
        ret = ret.filter(
          (c) =>
            !this.contract.customer_company.customer.company_ids.includes(c.id)
        );
      }

      return ret;
    },
    getEditedItem() {
      let shipping_company_id;
      if (
        this.supplierShippingCompanies().find(
          (e) => e.id === this.editedItem.shipping_company_id
        )
      )
        shipping_company_id = this.editedItem.shipping_company_id;
      else shipping_company_id = null;
      return {
        id: this.editedItem.id,
        contract_id: this.contract.id,
        net_weight: parseFloat(this.editedItem.net_weight),
        quantity: parseInt(this.editedItem.quantity),
        etd: this.editedItem.etd,
        shipment_id: this.editedItem.shipment_id,
        shipping_company_id: shipping_company_id,
        previsional: this.previsional,
      };
    },
    initItem() {
      const netWeightProducts = this.getNetWeightProducts();
      const netWeightExpeditions = this.getNetWeightExpeditions();
      var netWeight = 0;
      if (netWeightProducts > netWeightExpeditions)
        netWeight = netWeightProducts - netWeightExpeditions;
      const supplier = this.contract.supplier_company.supplier;
      const customer = this.contract.customer_company.customer;
      const forbidden_company_ids = customer.company_ids;
      const shipments = supplier.shipments;
      const shipping_companies = supplier.shipping_companies;
      /* Find the first valid couple : shipment-shipping_company */
      var shipment_id = "";
      var shipping_company_id = "";
      for (var i = 0; i < shipping_companies.length; i++) {
        if (forbidden_company_ids.includes(shipping_companies[i].id)) continue;
        if (!shipping_companies[i].supplier) continue;
        for (var j = 0; j < shipments.length; j++) {
          if (
            shipping_companies[i].supplier.shipment_ids.includes(
              shipments[j].id
            )
          ) {
            shipment_id = shipments[j].id;
            shipping_company_id = shipping_companies[i].id;
            break;
          }
        }
      }
      return {
        id: "new",
        contract_id: "",
        net_weight: netWeight,
        quantity: 1,
        etd: new Date().toISOString().substr(0, 10),
        shipment_id: shipment_id,
        shipment: {
          name: shipments.length > 0 ? shipments[0].name : "",
        },
        previsional: this.previsional,
        shipping_company_id: shipping_company_id,
        shipping_company: {
          name: shipping_companies.length > 0 ? shipping_companies[0].name : "",
        },
      };
    },
    setEditedItem(item) {
      this.editedItem = {
        id: item.id,
        contract_id: item.contract_id,
        net_weight: item.net_weight,
        etd: item.etd,
        shipment_id: item.shipment_id,
        bl_number: item.bl_number,
        vessel_name: item.vessel_name,
        shipment: {
          name: "",
        },
        shipping_company_id: item.shipping_company_id,
        shipping_company: {
          name: "",
        },
        quantity: item.quantity,
      };
    },
    optimistic() {
      let id = this.editedItem.id;

      let shiping_company = this.contract.supplier_company.supplier.shipping_companies.find(
        (e) => e.id === this.editedItem.shipping_company_id
      );

      var changes = {
        net_weight: this.editedItem.net_weight,
        etd: this.editedItem.etd,
        shipment_id: this.editedItem.shipment_id,
        shipping_company_id: this.editedItem.shipping_company_id,
        quantity: this.editedItem.quantity,
        shipment: {
          id: this.editedItem.shipment_id,
          name: this.getNameById(this.editedItem.shipment_id, "shipments"),
        },
        shipping_company: {
          id: this.editedItem.shipping_company_id,
          name: shiping_company ? shiping_company.name : "",
        },
      };
      this.applyOptimistic(this.editableItems, id, changes);
    },
    getHeaderTitle(header) {
      if (header.shortText) return header.shortText;
      return header.text;
    },
  },
};
</script>

<style lang="stylus" scoped>
.small-font {
  font-size: small;
}

.min-width-action {
  min-width: 100px;
}

.min-width-column {
  min-width: 18em;
}

.clickable {
  cursor: pointer;
  height: 22px;
}

.borderedTitle {
  border-bottom: 2px solid #eaeaea;
}
</style>
<style>
.bordered > .v-toolbar__content {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.small-font input {
  padding: 5px;
}

.small-font .v-select__selection--comma {
  margin-left: 5px;
}

@media only screen and (min-width: 1524px) {
  .largehead {
    display: inline-block;
  }
  .smallhead {
    display: none;
  }
}

@media only screen and (max-width: 1523px) {
  .largehead {
    display: none;
  }
  .smallhead {
    display: inline-block;
  }
}
</style>
